//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('universalUploadOverlayHost', {

    template: `
      <image-uploader
        name="universal-overlay"
        ng-if="$ctrl.imageUploaderEnabled()"
        ng-attr-style="{{$ctrl.useLegacyStyle ? 'position:absolute' : undefined}}"
        ng-attr-legacy-dark-overlay="{{$ctrl.useLegacyStyle || undefined}}"
        use-noop-toast-notification-service="$ctrl.disableToastNotification"
        mode="overlay"
      ></image-uploader>
    `,
    controller: [
      '$rootScope',
      'ContentDrawerSettingsService',
      function(
        $rootScope,
        ContentDrawerSettingsService,
      ) {
        this.useLegacyStyle = false;
        this.disableToastNotification = true;

        const setPageSettings = (settings) => {
          if (settings.useLegacyImageUploaderStyle) {
            this.useLegacyStyle = true;
          }

          if (settings.enableToastNotification) {
            this.disableToastNotification = false;
          }
        };

        const unsetPageSettings = () => {
          this.useLegacyStyle = false;
          this.disableToastNotification = true;
        };

        $rootScope.$on('universal-upload:set-page-settings', (event, settings) => {
          setPageSettings(settings);
        });

        $rootScope.$on('universal-upload:unset-page-settings', () => {
          unsetPageSettings();
        });

        $rootScope.$on('universal-upload:set-override-settings', (event, settings) => {
          setPageSettings(settings);
        });

        $rootScope.$on('universal-upload:unset-override-settings', () => {
                    // reset back to initial
          unsetPageSettings();
        });

        this.imageUploaderEnabled = () => {
          return !ContentDrawerSettingsService.getPageSettings().disableImageUploader;
        };
      },
    ],
  });
})();
